const Policy = () => (
	<div style={{textAlign: "justify"}}>


	  <p>Atat&uuml;rk Araştırma Merkezi Başkanlığınca hazırlanan ve dijital ortamda erişime a&ccedil;ılmış olan T&uuml;rk D&uuml;nyası Ansiklopedisi internet sitesine hoş geldiniz. Bu b&ouml;l&uuml;m, T&uuml;rk D&uuml;nyası Ansiklopedisi internet sitesi ziyaret ve kullanım koşullarını i&ccedil;ermektedir. L&uuml;tfen siteyi kullanmadan &ouml;nce kullanım koşullarını dikkatlice okuyunuz.</p>



<p>Bu İnternet sitesi (Bundan b&ouml;yle &ldquo;site&rdquo; olarak anılacaktır.) i&ccedil;eriğinde yer alan t&uuml;m eserler (yazı, resim, g&ouml;r&uuml;nt&uuml;, fotoğraf, video, m&uuml;zik vb.) Atat&uuml;rk Araştırma Merkezi Başkanlığına (Bundan b&ouml;yle &ldquo;Kurum&rdquo; olarak anılacaktır.) ait olup 5846 sayılı Fikir ve Sanat Eserleri Kanunu ve 5237 sayılı T&uuml;rk Ceza Kanunu kapsamında korunmaktadır. Bu hakları ihlal eden kişiler, 5846 sayılı Fikir ve Sanat eserleri Kanunu ve 5237 sayılı T&uuml;rk Ceza Kanununda yer alan hukuki ve cezai yaptırımlara tabi olurlar. Kurum ihlalde bulunan ilgili hakkında yasal işlem başlatma hakkına sahiptir.</p>



<p>Siteye erişim ve sitenin kullanımı aşağıdaki esas ve şartlara tabidir. Bu sitenin herhangi bir sayfasına girilmesi halinde aşağıda belirtilen kullanım koşulları kabul edilmiş sayılır. Bu koşulların kabul edilmemesi durumunda siteye girilmemelidir.</p>



<p>Kullanım Koşulları</p>



<p>1-Bu sitedeki t&uuml;m materyallerin telif hakları Atat&uuml;rk Araştırma Merkezi Başkanlığına aittir. Kullanıcılar bilgi ve dok&uuml;manları herhangi bir ticari ve &ccedil;ıkar amacı olmadan sadece kişisel bilgi edinmek amacıyla kullanabilir.</p>



<p>2-Bu sitede yer alan t&uuml;m eserler Kurumun yazılı izni olmaksızın değiştirilemez, &ccedil;oğaltılamaz, yayımlanamaz, dağıtılamaz, umuma iletilemez, başka bir lisana &ccedil;evrilemez.</p>



<p>3-Bu siteden yazılı ve/veya g&ouml;rsel nitelikte bilgi indirme, baskı alma ve internet sitelerinde kullanma ancak aşağıdaki koşullar d&acirc;hilinde yapılabilir:</p>



<p>3.1. Sitede yer alan eserlerin kullanımı kişisel kullanım ve/veya bilgi edinme amacı ile sınırlıdır. Ancak bu kapsamda ger&ccedil;ekleştirilen &ccedil;oğaltma fiilleri hak sahibinin meşru menfaatlerine haklı bir sebep olmadan zarar veremez ya da eserden normal yararlanmaya aykırı olamaz, ticari ama&ccedil;la kullanılamaz.</p>



<p>3.2. Sitedeki yazılı veya g&ouml;rsel materyal hi&ccedil; bir şekilde değiştirilemez, telif hakkı ibareleri silinerek kullanılamaz.</p>



<p>3.3. Sitede yer alan eserlerin b&uuml;t&uuml;n&uuml; veya bir kısmı değiştirilerek veya başka bir suretle diğer bir internet sitesinde izinsiz olarak kullanılamaz.</p>



<p>3.4. Bu sitedeki veriler ancak ticari olmayan, bilgi alma ama&ccedil;lı ve kişisel kullanım i&ccedil;in indirebilir veya yazdırılabilir.</p>



<p>3.5. Bu sitedeki verileri herhangi bir ticari ama&ccedil; olmadan &uuml;&ccedil;&uuml;nc&uuml; şahıslara onların kişisel bilgilendirilmeleri i&ccedil;in, i&ccedil;eriğin Kurum tarafından sağlandığını, bu kayıt ve şartların onlara da uygulandığını ve bunlara uymak zorunda olduklarını belirtmek şartıyla g&ouml;nderilebilir.</p>



<p>4-Kurum sitenin 24 saat erişilebilir olmasını sağlamaktadır. Ancak değişik sebeplerle sitenin erişilebilir olmamasından sorumlu değildir. Siteye erişim, herhangi bir duyuru yapılmaksızın ge&ccedil;ici veya s&uuml;rekli olarak durdurulabilir. Sitede yer alan t&uuml;m bilgiler &ouml;nceden haber verilmeksizin değiştirilebilir. Kurum dilediği zaman, sitenin herhangi bir b&ouml;l&uuml;m&uuml;n&uuml; iptal edebilir, haber vermeksizin sitedeki bazı &ouml;zellikleri veya bilgileri değiştirebilir veya sitenin bazı b&ouml;l&uuml;mlerine erişimi sınırlandırabilir.</p>



<p>(Kurum bu yasal uyarıda yer alan t&uuml;m koşulları ve h&uuml;k&uuml;mleri &ouml;nceden bir ihbara gerek kalmaksızın değiştirme ve g&uuml;ncelleme hakkını haizdir. &ldquo;Gizlilik politikası ve Sorumluluk reddi&rdquo;ni d&uuml;zenli olarak takip etmek, site kullanıcısının sorumluluğundadır. Yapılan değişikliklerden sonra siteyi kullanmaya devam eden kişi, &ldquo;Gizlilik politikası ve Sorumluluk reddi&rdquo;ndeki değişiklikleri kabul etmiş sayılır.)</p>


	</div>
  );
  
  export default Policy;
  